// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import footerBG from './js/widgets/footerBG.js';
import * as socialFeed from './js/widgets/socialFeed.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

const isMobile = window.matchMedia('(max-width: 799px)').matches;

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidget();
    cardWidget();
    seoWidget();
    sponsors();
  });
  $(window).load(function () {
    // socialFeed.instafeed(false);
    if (!isMobile) {
      socialFeed.facebookfeed(true);
    }
    if (isMobile) {
      $('#socialNetworkWidget').hide();
    }
    // if (isMobile) {
    //   $('#instafeedTab').click();
    //   setTimeout(function () {
    //     if (!$('#instafeedContainer').html().length) {
    //       $('#multiSocialWidget').hide();
    //     }
    //   }, 1000);
    // }
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  footerBG();
});
$(window).load(function () {
  // Initialize Custom Theme Scripts
});
